import React, { useEffect, useState, useCallback } from 'react'
import nav from '../images/GDSC logo.png'
import "../Register.css"
import { getDatabase, ref, onValue } from "firebase/database";
import { useUserAuth } from "../context/UserAuthContext";
import logout from '../images/logout.png'
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import Swal from 'sweetalert2'

const Register = () => {
  const [FirstName, setFirstName] = useState('');
  const [Status, setStatus] = useState('');
  const { user } = useUserAuth();
  const [isLogin, setIsLogin] = useState(true);

  const handleShow = useCallback(() => {
    // e.preventDefault();
    const db = getDatabase();
    onValue(ref(db, user.uid), (snapshot) => {
      if (snapshot.val().userid === user.uid) {
        setFirstName(snapshot.val().FirstName);
        setStatus(snapshot.val().Status);
        // console.log(snapshot.val());
      }
    })

  }, [user.uid]);


  useEffect(() => {
    const db = getDatabase();
    // console.log(user.uid);
    onValue(ref(db, user.uid), (snapshot) => {
      if (snapshot.val() === null) {
        setIsLogin(false);
        Swal.fire({
          title: 'Not Registered!',
          text: "You are not registered yet! Go and register now!",
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Go to Register'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location = '/auth';
          }else{
            window.location = '/auth';
          }
        }
        )
      } else {
        return handleShow();
      }
    })
  }, [user.uid, user.email, handleShow])

  

  const handleLogoutConfirm = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
        Swal.fire(
          'Logged Out!',
          'You are logged out successfully!',
          'success'
        )
      }
    }
    )
  }


  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
      <div className="absolute object-left-top">
        <div className="Header_nav-logo">
          <img src={nav} className="navbar-image" alt="home img" />
          <p className="text">
            Google Developer Student Clubs
            <br />
            GLA University
          </p>
        </div>
      </div>
      <div className='question-image' onClick={handleLogoutConfirm}>
        <img src={logout} alt="question" className='font-gelionMedium' />
      </div>
      {isLogin ? (
      <div className="helper3" style={{ paddingTop: '3rem' }}>
        {/* <div className="congrulations">
          <h1>Congratulations!</h1>
          <h2>You have successfully registered for GDSC GLAU 2022</h2>
          <p>Your contact email : {user.email}</p>
        </div> */}
        <section className='user-table'>
          <div className='container3'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='user-table-content'>
                  <div className='container3-header'>
                    <span className='warning'>Status of your application will change if there any progress in your application.</span>
                    <table className="ui celled table">
                      <thead>

                        <tr>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{FirstName}</td>
                          <td className={Status}>{Status}</td>
                          <td>None</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>Please check your mail for more information.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> ) : (
        <div className="blank-page"></div> ) }
    </>
  )
}

export default Register